import React, {useEffect, useState, useRef} from "react";
import {
    Grid,
    Card,
    CardContent,
    Hidden,
    Box,
    useTheme,
    useMediaQuery,
} from "@material-ui/core";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";

import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import {
    Layout,
    Container,
    Button,
    Questions,
    MainSection,
    DarkSection,
    Curve,
    Image,
} from "components";
import Swiper from "react-id-swiper";
import {Link} from "react-router-dom";
import {throttle} from "lodash";
import clsx from "clsx";
import {imageCellphone, imageText, imageTower} from "./images"

import content from "_constants/content.json";

import "./styles.sass";

function PlanPage(layoutProps: any): React.ReactElement {
    const swiper = useRef(null);
    const [slider, setSlider] = useState(null);
    const [sliderIndex, setSliderIndex] = useState(1);
    const [hideBanner, setHideBanner] = useState(false);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.only("xs"));

    const price = 9.99;
    const additionalItemPrice = 3.99;

    const sliderOptions = {
        ref:  swiper,
        slidesPerView: 3,
        spaceBetween: 0,
        initialSlide: sliderIndex,
        centeredSlides: true,
        slideToClickedSlide: true,
        breakpoints: {
            0: {
                slidesPerView: "auto" as const,
                spaceBetween: 0,
            },
            600: {
                slidesPerView: 3,
                spaceBetween: 0,
            },
        },
    };

    useEffect(()=>{
        if(swiper.current){
            // @ts-ignore: Object is possibly 'null'.
            setSlider(swiper.current.swiper);
        }
    });

    useEffect(() => {
        if (slider) {
            // @ts-ignore: Object is possibly 'null'.
            slider.on("slideChange", () => {
                // @ts-ignore: Object is possibly 'null'.
                setSliderIndex(slider.realIndex);
            });
        }
    }, [slider]);

    useEffect(() => {
        const handleHideBanner = () => {
            if (window.scrollY <= 0) setHideBanner(true);
            if (window.scrollY > 0 && hideBanner === true) {
                setHideBanner(false);
            }
        };
        window.addEventListener("scroll", handleHideBanner);
        return (): void => {
            window.removeEventListener("scroll", handleHideBanner);
        };
    }, [hideBanner]);

    const onClickPrev = (): void => {
        if (slider) {
            // @ts-ignore: Object is possibly 'null'.
            slider.slidePrev();
        }
    };

    const onClickNext = (): void => {
        if (slider) {
            // @ts-ignore: Object is possibly 'null'.
            slider.slideNext();
        }
    };

    useEffect(() => {
        const handleUserKeyPress = (event: any) => {
            if (event.code === 'ArrowRight')
                onClickNext();
            if (event.code === 'ArrowLeft')
                onClickPrev();
        }

        window.addEventListener('keydown', handleUserKeyPress);
        return () => window.removeEventListener('keydown', handleUserKeyPress);
    });

    const carsoulNodeRef = useRef(null);
    const [carsoulNodeVisible, setCarsoulNodeVisible] = useState(false);
    const [carsoulNodeOnTop, setCarsoulNodeOnTop] = useState(false);
    const isCarsoulInViewport = (startOffset = 0, endOffset = 0) => {
        let visible = false;
        let onTop = false;
        let onBottom = false
        if (carsoulNodeRef) {
            const carsoulElement = (carsoulNodeRef.current as unknown) as HTMLElement;
            if (carsoulElement) {
                const {top} = carsoulElement.getBoundingClientRect();
                const {bottom} = carsoulElement.getBoundingClientRect();
                onTop = top + startOffset <= window.innerHeight;
                onBottom = bottom + endOffset >= 0;
                visible = onTop && onBottom;
            }
        }
        return [visible, onTop];
    };

    useEffect(() => {
        const handleScroll = () => {
            const [visible, onTop] = isCarsoulInViewport(150, -200);
            setCarsoulNodeVisible(visible);
            setCarsoulNodeOnTop(onTop)
        };

        const throttledListener = throttle(handleScroll, 100);
        window.addEventListener("scroll", throttledListener);

        return () => window.removeEventListener("scroll", throttledListener);
    }, [carsoulNodeVisible]);

    const stickyBanner = () => {
        return (
            <Container className="plan-banner-container">
                <Grid container justify="center">
                    <Grid item xs={12} md={10}>
                        <div className="plan-banner-content flex-row align-center justify-center">
                            <div className="content-wrapper">
                                <h2 className="amount">
                                    $
                                    {(!content.plans[sliderIndex].final) ?
                                        (
                                            (
                                                price +
                                                content.plans[sliderIndex].price
                                            ).toFixed(2)
                                        ) : (
                                            content.plans[sliderIndex].price
                                        )
                                    }
                                </h2>
                                <p className="text">
                                    {
                                        (!content.plans[sliderIndex].customMessage) ?
                                            (
                                                <span>1GB Mobi Plan <br/>{content.plans[sliderIndex].addOnName}</span>
                                            ) : (
                                                <span>{content.plans[sliderIndex].customMessage}</span>
                                            )
                                    }
                                </p>
                            </div>
                            <Link to="/get-started">
                                <Button btnColor="gradient" className="button">
                                    Get Started
                                </Button>
                            </Link>
                        </div>
                    </Grid>
                </Grid>
            </Container>
        );
    };

    return (
        <Layout className="page-plan" {...layoutProps}>
            <MainSection
                title={
                    <div>
                        One affordable plan <br/>and price for everyone.
                    </div>
                }
                text="Only pay for unlimited data if you need it."
            >
                <Grid container justify="center" className="plan-card-wrapper">
                    <Card className="plan-card">
                        <CardContent>
                            <div className="plan-list-wrapper">
                                <ul className="plan-list">
                                    <li className="item text-center justify-center flex-row">
                                        <h3>The Mobi Plan</h3>
                                    </li>
                                    <li className="item">
                                        <div className="icon flex-row justify-center">
                                            <Image
                                                src={imageCellphone}
                                                alt="Unlimited Talk"
                                            />
                                        </div>
                                        <span>Unlimited Talk</span>
                                    </li>
                                    <li className="item">
                                        <div className="icon flex-row justify-center">
                                            <Image src={imageText} alt="Unlimited Text"/>
                                        </div>
                                        <span>Unlimited Text</span>
                                    </li>
                                    <li className="item">
                                        <div className="icon flex-row justify-center">
                                            <Image
                                                src={imageTower}
                                                alt="1 GB of LTE Data"
                                            />
                                        </div>
                                        <span>1GB of LTE Data</span>
                                    </li>
                                </ul>
                            </div>
                            <div className="plan-line"/>
                            <div className="plan-price flex-row align-center justify-center">
                                <h2 className="plan-amount">${price}</h2>
                                <p className="plan-text">
                                    per month <br/>
                                    + tax
                                </p>
                            </div>
                        </CardContent>
                    </Card>
                </Grid>
            </MainSection>

            <DarkSection top={isMobile ? 10 : 4}>
                <div className="plans">
                    <Container>
                        <div className="plans-header">
                            <h2 className="plans-title">+</h2>
                            <h2 className="plans-title plans-title-mobile">
                                Need more data?{" "}
                                <br className="text-desktop-width-breakpoint"/> Each additional GB is{" "}
                                <span className="plans-title-sub">
                  ${additionalItemPrice}.
                </span>
                            </h2>
                            <p className="plans-description">
                                Only pay for the additional data you use each month.
                            </p>
                        </div>
                    </Container>

                    <div ref={carsoulNodeRef}>
                        <Hidden smUp>
                            <div className="plan-slider">
                                <Swiper {...sliderOptions}>
                                    {content.plans.map((item, index) => (
                                        (index === content.plans.length - 1) ?
                                            <div key={String(index)} className="plan-card flex-row">
                                                <div className='plan-divider' />
                                                <div className="plan-card-bg plan-card-bg-absolute">
                                                    <div>
                                                        <p className="plan-text">+ {item.gb}GB</p>
                                                        <h4 className="plan-title">{item.title}</h4>
                                                        {(item.subtitle) ? (
                                                            <h3 className="plan-subtitle">{item.subtitle}</h3>
                                                        ) : null}
                                                    </div>
                                                </div>
                                            </div>:
                                            <div key={String(index)} className="plan-card plan-card-bg">
                                                <p className="plan-text">+ {item.gb}GB</p>
                                                <h4 className="plan-title">{item.title}</h4>
                                                {(item.subtitle) ? (
                                                    <h3 className="plan-subtitle">{item.subtitle}</h3>
                                                ) : null}
                                            </div>
                                    ))}
                                </Swiper>
                            </div>
                        </Hidden>

                        <Hidden only="xs">
                            <Container disableGutters className="plan-slider-container">
                                <Grid container justify="center">
                                    <Grid item sm={1} className="plan-slider-action-wrapper">
                                        <div className="plan-slider-action">
                                            <ArrowBackIosIcon
                                                className="icon"
                                                onClick={onClickPrev}
                                            />
                                        </div>
                                    </Grid>
                                    <Grid item xs={12} sm={10}>
                                        <div className="plan-slider">
                                            <Swiper {...sliderOptions}>
                                                {content.plans.map((item, index) => (
                                                    (index === content.plans.length - 1) ?
                                                    <div key={String(index)} className="plan-card flex-row">
                                                        <div className='plan-divider' />
                                                        <div className="plan-card-bg plan-card-bg-absolute">
                                                            <div>
                                                                <p className="plan-text">+ {item.gb}GB</p>
                                                                <h4 className="plan-title">{item.title}</h4>
                                                                {(item.subtitle) ? (
                                                                    <h3 className="plan-subtitle">{item.subtitle}</h3>
                                                                ) : null}
                                                            </div>
                                                        </div>
                                                    </div>:
                                                    <div key={String(index)} className="plan-card plan-card-bg">
                                                        <p className="plan-text">+ {item.gb}GB</p>
                                                        <h4 className="plan-title">{item.title}</h4>
                                                        {(item.subtitle) ? (
                                                            <h3 className="plan-subtitle">{item.subtitle}</h3>
                                                        ) : null}
                                                    </div>
                                                ))}
                                            </Swiper>
                                        </div>
                                    </Grid>
                                    <Grid item sm={1} className="plan-slider-action-wrapper">
                                        <div className="plan-slider-action justify-end">
                                            <ArrowForwardIosIcon
                                                className="icon"
                                                onClick={onClickNext}
                                            />
                                        </div>
                                    </Grid>
                                </Grid>
                            </Container>
                        </Hidden>
                    </div>
                </div>
            </DarkSection>


            <Hidden smUp>
                <Box>
                    <Curve reverse={true}/>
                </Box>
            </Hidden>

            <Container>
                <div className="faq">
                    <Questions
                        items={[
                            {
                                question: "Do you have other plans?",
                                answer: "We like to keep it simple with one affordable plan for all of our customers. The Mobi Plan includes unlimited talk, text, and a GB of high-speed data each month.",
                            },
                            {
                                question: "Do you offer family plans?",
                                answer: "Because the Mobi Plan is so affordable, you can add as many separate lines to your account as you need to and still save big on your family’s cell service.",
                            },
                            {
                                question: "What if I need more data?",
                                answer: "Add as much (or as little) data to your plan as you need. Each additional GB of high speed data is just $3.99. You can also add unlimited slower speed for things like light web browsing, streaming music and podcasts, and messaging for $8.99 per month, plus tax. \n You can also opt-in for our 10GB add-on for $24.99 per month, plus tax, which gives you 10GB of high-speed data as well as access to unlimited data at a slower speed once the 10GB is used up. Plus. when that's up we'll give you unlimited slower speeds at no extra charge.",
                            },
                            {
                                question: "What extra charges and fees will show up on my Mobi bill?",
                                answer: "We collect taxes and regulatory fees based on your billing address, which are outlined on your bill.  Taxes vary pretty widely from state to state and even city to city but they're generally just a few dollars. Contact us for a regional estimate.",
                            },
                            {
                                question: "Is your service prepaid or postpaid?",
                                answer: "Prepaid: No contracts. No credit checks. No commitments.",
                            },
                            {
                                question: "Can I get your service with an eSIM?",
                                answer: "Yes, providing your device is unlocked and an eSIM-capable device compatible with our network.",
                            },
                            {
                                question: "Do you offer 5G network connectivity?",
                                answer: "Yes, in select areas for compatible devices… and at no extra charge!. With 5G, you can experience faster download speeds, lower latency, and improved network performance. If 5G isn’t available in your area, you can still enjoy great 4G Mobi service. ",
                            },
                            {
                                question: "Do I have to sign a contract?",
                                answer: "Nope! You just have to agree to our terms of service. (The gist is: don’t break the law, don’t blame us for things we can’t control, and be reasonable. We'll do the same!). With no contract, there’s no commitment. You can cancel your service at any time.",
                            },
                            {
                                question: "Can I change my plan midway through the month?",
                                answer: "Yup, generally.  Some add-ons might be prorated, might not be retroactive, or might have other restrictions, but you can always add more data or remove add-ons effective immediately. Check back soon for an option to make changes via the Mobi App or Site.",
                            },
                            {
                                question: "What methods of payment can I use?",
                                answer: "A major credit or debit card is fine, including Visa, MasterCard, American Express, and Discover. We’re working on JCB, and we might look at Amazon Pay in the future. Apple Pay or Google Pay is great too. No Bitcoin or PayPal for now.",
                            },
                            {
                                question: "Can I add my wearables or tablet?",
                                answer: "Stay tuned! Soon it will be possible for you to add your Apple Watch to your Mobi account for free (you’ll just pay for whatever extra data usage your Apple Watch uses based on its paired iPhone). You'll also soon be able to add your iPad to your Mobi account via eSIM for just $0.99 per month plus data.",
                            },
                            {
                                question: "Do you offer international calling?",
                                answer: "Not yet but we know it's important to our customers and we are actively looking into it. \n In the meantime, there are many third-party apps and services available that allow you to make free international calls using Wi-Fi or data. You can also purchase international calling cards from a variety of providers.    ",
                            },
                            {
                                question: "Does mobi support VoLTE?",
                                answer: "Yes, mobi supports voice-over LTE technology so long as your device is compatible.",
                            },
                        ]}
                    />
                </div>
            </Container>

            <div className="plan-banner-wrapper">
                <div className="flex"></div>
                <div
                    className={clsx(
                        "plan-banner",
                        carsoulNodeVisible && "show-mobile",
                        carsoulNodeOnTop && "show-desktop",
                        hideBanner && "hide"
                    )}
                >
                    {stickyBanner()}
                </div>
            </div>

            <Hidden only="xs">
                <div className="line"/>
            </Hidden>
        </Layout>
    );
}

export default PlanPage;

